import React from 'react';
import { useQuery } from 'utils/react-query';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import get from 'lodash/get';

import { useTranslation, Router, Trans } from 'src/i18n';
import { TP } from 'constants/index';
import route from 'constants/routes';

import queries from 'containers/Globals/queries';

import Image from 'components/uiLibrary/Image';
import H1 from '../H1';
import ParseHtml from '../ParseHtml';
import styles from './SearchBg.module.scss';

const SearchBg = () => {
  const { t } = useTranslation('NS_APP_GLOBALS');
  const { data } = useQuery(queries.getHomeNumbers());

  const staticInfo = [
    { number: get(data, 'data.performances.total'), info: 'operabase.general.m_PERF' },
    { number: get(data, 'data.companies.total'), info: 'operabase.general.m_OPCOS' },
    { number: get(data, 'data.festivals.total'), info: 'operabase.general.m_FESTIVALS' },
    { number: get(data, 'data.artists.total'), info: 'operabase.general.m_ARTISTS' },
    { number: get(data, 'data.managers.total'), info: 'operabase.general.m_MANAGERS' },
  ];

  const handleButton = () => {
    Router.push({
      pathname: route.DETAILS_ARTISTS,
    });
  };

  return (
    <div className={styles.searchBg}>
      <Image
        src="https://images.operabase.com/image/upload/w_3840/opera_exfrog.jpg"
        srcSet={[
          {
            path: 'https://images.operabase.com/image/upload/f_avif,w_640/opera_exfrog.jpg',
            type: 'image/avif',
            width: 640,
          },
          {
            path: 'https://images.operabase.com/image/upload/f_avif,w_750/opera_exfrog.jpg',
            type: 'image/avif',
            width: 750,
          },
          {
            path: 'https://images.operabase.com/image/upload/f_avif,w_828/opera_exfrog.jpg',
            type: 'image/avif',
            width: 828,
          },
          {
            path: 'https://images.operabase.com/image/upload/f_avif,w_1080/opera_exfrog.jpg',
            type: 'image/avif',
            width: 1080,
          },
          {
            path: 'https://images.operabase.com/image/upload/f_avif,w_1200/opera_exfrog.jpg',
            type: 'image/avif',
            width: 1200,
          },
          {
            path: 'https://images.operabase.com/image/upload/f_avif,w_1280/opera_exfrog.jpg',
            type: 'image/avif',
          },
          {
            path: 'https://images.operabase.com/image/upload/f_webp,w_640/opera_exfrog.jpg',
            type: 'image/webp',
            width: 640,
          },
          {
            path: 'https://images.operabase.com/image/upload/f_webp,w_750/opera_exfrog.jpg',
            type: 'image/webp',
            width: 750,
          },
          {
            path: 'https://images.operabase.com/image/upload/f_webp,w_828/opera_exfrog.jpg',
            type: 'image/webp',
            width: 828,
          },
          {
            path: 'https://images.operabase.com/image/upload/f_webp,w_1080/opera_exfrog.jpg',
            type: 'image/webp',
            width: 1080,
          },
          {
            path: 'https://images.operabase.com/image/upload/f_webp,w_1200/opera_exfrog.jpg',
            type: 'image/webp',
            width: 1200,
          },
          {
            path: 'https://images.operabase.com/image/upload/f_webp,w_1280/opera_exfrog.jpg',
            type: 'image/webp',
          },
        ]}
        alt="background"
        lazy={false}
        disableCloudinary
        disableNextImage
        preload
        className={styles.bg}
      />
      <div className={styles.mainContent}>
        <H1 className={styles.mainHeading}>
          <ParseHtml>{`<span>${t('operabase.general.m_HOMETOP1')}</span>`}</ParseHtml>
        </H1>
        {data && (
          <div className={styles.stats}>
            {staticInfo.map(item => (
              <div className={styles.statItem} key={item.info}>
                {item.number && item.number.toLocaleString()} <span className={styles.statInfo}>{t(item.info)}</span>
              </div>
            ))}
          </div>
        )}
      </div>
      <div className={styles.newContent}>
        <div className={styles.header}>{t(`${TP}.PRO_PAGE_INDUSTRY`)} </div>
        <div className={styles.content}>
          <Trans
            i18nKey={`${TP}.PRO_TOOLS`}
            components={{
              pro: <span className={styles.pro} />,
            }}
          />
        </div>
        <button className={styles.button} onClick={handleButton} type="button">
          {t(`${TP}.FN_LEARNMORE`)} <ArrowForwardIosIcon className={styles.icon} />
        </button>
      </div>
    </div>
  );
};

export default SearchBg;
